export default (function convertRegionsToPositionMap(regions, alignment) {
  let positionMap = {};
  const alignmentToFlexMap = {
    'start': 'start',
    'center': 'center',
    'end': 'end',
    'left': 'start',
    'right': 'end'
  };
  const alignmentMap = {
    'start': 'left',
    'center': 'center',
    'end': 'right'
  };
  regions.forEach(region => {
    try {
      let startingXPos = "start",
        endingXPos = "start",
        startingYPos = "start",
        endingYPos = "start",
        xPos = "center",
        yPos = "end";
      let regionId = region['@_xml:id'];
      if (!regionId) {
        return;
      }
      let regionExtent = region['@_tts:extent'];
      let regionOrigin = region['@_tts:origin'];
      let regionDisplayAlign = region['@_tts:displayAlign'];
      let regionTextAlign = alignment || region['@_tts:textAlign'] || "center";
      let originX = parseFloat(regionOrigin ? regionOrigin.split(' ')[0].replace("%", "") : 10);
      let originY = parseFloat(regionOrigin ? regionOrigin.split(' ')[1].replace("%", "") : 10);
      let extentX = parseFloat(regionExtent ? regionExtent.split(' ')[0].replace("%", "") : 80);
      let extentY = parseFloat(regionExtent ? regionExtent.split(' ')[1].replace("%", "") : 80);

      // Determine horizontal position based on origin
      if (originX <= 10) {
        startingXPos = "start";
      } else if (originX <= 90) {
        startingXPos = "center";
      } else {
        startingXPos = "end";
      }
      if (originX + extentX <= 40) {
        endingXPos = "start";
      } else if (originX + extentX <= 60) {
        endingXPos = "center";
      } else {
        endingXPos = "end";
      }
      if (startingXPos === endingXPos) {
        xPos = startingXPos;
      } else if (startingXPos === "start" && endingXPos === "center") {
        xPos = "start";
      } else if (startingXPos === "center" && endingXPos === "end") {
        xPos = "end";
      } else if (startingXPos === "start" && endingXPos === "end") {
        xPos = alignmentToFlexMap[alignment] || "center";
      } else {
        xPos = "center";
      }

      // Determine vertical position based on origin
      if (originY < 40) {
        startingYPos = "start";
      } else if (originY < 60) {
        startingYPos = "center";
      } else {
        startingYPos = "end";
      }

      // Determine ending vertical position
      if (originY + extentY <= 40) {
        endingYPos = "start";
      } else if (originY + extentY <= 60) {
        endingYPos = "center";
      } else {
        endingYPos = "end";
      }

      // Set final vertical position based on displayAlign
      if (regionDisplayAlign === "before") {
        yPos = startingYPos;
      } else {
        yPos = endingYPos;
      }
      positionMap[regionId] = {
        xPos: xPos || "center",
        yPos: yPos || "end",
        alignment: regionTextAlign || "center"
      };
    } catch (err) {
      //console.log(err);
    }
  });
  return positionMap;
});